import { atlasRoutes } from "@/app/router/routes";
import { Button } from "@/components/button";
import { api } from "@/modules/api";
import { fileModule } from "@/modules/file";
import { useState } from "react";
import { useNavigate } from "react-router";
import styled from "@emotion/styled";

export const AdminBadgesCreatePage = () => {
  const navigate = useNavigate();
  const [slug, setSlug] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imageUploadedFileId, setImageUploadedFileId] = useState<string | null>(null);

  const handleUploadImage = async () => {
    if (!imageFile) return;
    const { fileId } = await fileModule.uploadFile({ file: imageFile });
    setImageUploadedFileId(fileId);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post("/internal/v1/staff/badges", {
      body: {
        slug,
        name,
        description,
        image_uploaded_file_id: imageUploadedFileId ?? undefined,
      },
    });
    navigate(atlasRoutes.adminBadges({}).path);
  };

  return (
    <Container>
      <h1>Create Badge</h1>
      <Form onSubmit={handleSubmit}>
        <FormField>
          <Label>Slug</Label>
          <Input
            value={slug}
            onChange={e => setSlug(e.target.value)}
            placeholder="unique-badge-slug"
            required
          />
        </FormField>

        <FormField>
          <Label>Name</Label>
          <Input
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Badge Display Name"
            required
          />
        </FormField>

        <FormField>
          <Label>Description</Label>
          <TextArea
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Describe what this badge represents..."
            rows={4}
          />
        </FormField>

        <FormField>
          <Label>Image File</Label>
          <FileInput
            type="file"
            accept="image/*"
            onChange={e => setImageFile(e.target.files?.[0] ?? null)}
          />
          {imageFile && !imageUploadedFileId && (
            <Button type="button" onClick={handleUploadImage} style={{ marginTop: "8px" }}>
              Upload Image
            </Button>
          )}
          {imageUploadedFileId && <UploadStatus>Image uploaded</UploadStatus>}
        </FormField>

        <SubmitButton type="submit">Create Badge</SubmitButton>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  color: #333;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const TextArea = styled.textarea`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const FileInput = styled.input`
  padding: 4px;
  font-size: 14px;
`;

const UploadStatus = styled.span`
  color: #28a745;
  font-size: 14px;
  margin-top: 8px;
`;

const SubmitButton = styled(Button)`
  margin-top: 16px;
  align-self: flex-start;
`;
